export const enum SectionTypes {
  header = 'header',
  promotion = 'promotion',
  products = 'products',
  faq = 'faq',
  gallery = 'gallery',
  bio = 'bio',
  review = 'review'
}
